import { useState, useMemo } from "react";
import { ITreeNode } from '../../common/types/commonTypes';
import { selector as groupApi } from './groupSlice';
import { useSelector } from "react-redux";

const useHandleGroupSearch = ({ isEditable }: { isEditable?: Boolean}) => {

    const initialNodes: ITreeNode[] = useSelector(groupApi).groupsHierarchy;
    const [groupSearchQuery, setGroupSearchQuery] = useState<string>('');
    const [filteredNodes, setFilteredNodes] = useState<ITreeNode[]>(initialNodes);
    const [searchExpandedValues, setSearchExpandedValues] = useState<string[]>([]);
 
    const handleGroupInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const query = event.target.value;
        setGroupSearchQuery(query);
        filterNodes(query);
    };

     const handleKeyDownForGroupSearch = (event: React.KeyboardEvent<HTMLInputElement>)=>{
        if (event.keyCode === 32 && isEditable) {
             setGroupSearchQuery(groupSearchQuery + ' ');
            filterNodes(groupSearchQuery + ' ');
        }
    }

  const filterNodes = (query: string) => {

   if (!query.trim()) {
      setFilteredNodes(initialNodes);
      setSearchExpandedValues([]);
      return;
   }

   const autoExpanded = new Set<string>();

   const filtered = filterTree(
      initialNodes,
      query,
      autoExpanded
   );

   setFilteredNodes(filtered);

   setSearchExpandedValues(
      Array.from(autoExpanded)
   );
  };
  const filterTree = (
    nodes: ITreeNode[],
    query: string,
    autoExpanded: Set<string>
  ): ITreeNode[] => {

    return nodes.reduce<ITreeNode[]>((acc, node) => {

      const label = String(node.label).toLowerCase();

      const children = node.children || [];

      const filteredChildren = filterTree(
        children,
        query,
        autoExpanded
      );

      const isMatch = label.includes(query.toLowerCase());

      if (isMatch || filteredChildren.length > 0) {

        if (filteredChildren.length > 0) {
          autoExpanded.add(String(node.value));
        }

        acc.push({
          ...node,
          children: filteredChildren,
        });
      }

      return acc;
    }, []);
  };

    const nodesToDisplay: ITreeNode[] = useMemo(() => (groupSearchQuery ? filteredNodes : initialNodes), [
        groupSearchQuery,
        filteredNodes,
        initialNodes,
    ]);

    return {
        handleGroupInputChange,
        groupSearchQuery,
        nodesToDisplay,
        setGroupSearchQuery,
        handleKeyDownForGroupSearch,
        searchExpandedValues
    }
}


export default useHandleGroupSearch;